import objectAssign from 'object-assign';
import { reportInitialState } from '../store/initialState';
import { clone } from './helper';
import {
  GET_REPORTS,
  GOT_REPORTS,
  ERROR_GETTING_REPROTS,
  UPDATE_SET_MIN_CON_DURATION_FORM,
  UPDATE_SET_MIN_MEETING_DURATION_FORM,
  UPDATE_MIN_DURATIONS,
  UPDATED_MIN_DURATIONS,
  UPDATE_START_DATE_FOR_REPORTS,
  UPDATE_END_DATE_FOR_REPORTS,
  RESET_MIN_DURATIONS,
  CHANGE_FETCHING_REPORTS,
  HIDE_DATA_OUTDATE_WARNING,
} from '../actions/report.js';

const reducer = (state = reportInitialState, action) => {
  switch (action.type) {
    case GET_REPORTS:
      return objectAssign({}, state, { fetchingReports: true });
    case CHANGE_FETCHING_REPORTS:
      return objectAssign({}, state, { fetchingReports: action.data });
    case HIDE_DATA_OUTDATE_WARNING:
      return objectAssign({}, state, { hideDataOutdateWarning: action.data });
    case GOT_REPORTS:
      return objectAssign({}, state, {
        fetchingReports: false,
        reports: action.data,
      });
    case ERROR_GETTING_REPROTS:
      return objectAssign({}, state, {
        fetchingReports: false,
        reports: {
          total: 0,
          active: 0,
          new: 0,
        },
      });
    case UPDATE_SET_MIN_CON_DURATION_FORM:
      return objectAssign({}, state, {
        typingMinConDurationValue: action.data,
      });
    case UPDATE_SET_MIN_MEETING_DURATION_FORM:
      return objectAssign({}, state, {
        typingMinMeetingDurationValue: action.data,
      });
    case UPDATE_MIN_DURATIONS:
      return objectAssign({}, state, {
        minConsultationDurValue: action.data[0],
        minMeetingDurValue: action.data[1],
        updatingMinDurations: true,
      });
    case UPDATED_MIN_DURATIONS:
      return objectAssign({}, state, {
        updatingMinDurations: false,
      });
    case UPDATE_START_DATE_FOR_REPORTS:
      return objectAssign({}, state, {
        startDate: action.data,
      });
    case UPDATE_END_DATE_FOR_REPORTS:
      return objectAssign({}, state, {
        endDate: action.data,
      });
    case RESET_MIN_DURATIONS:
      let copy0 = action.data.minConDur ? action.data.minConDur : clone(state.minConsultationDurValue);
      let copy1 = action.data.minMeetingDur ? action.data.minMeetingDur : clone(state.minMeetingDurValue);
      let newTypingMinConDurationValue = (copy0 / 60).toFixed(1);
      let newTypingMinMeetingDurationValue = (copy1 / 60).toFixed(1);
      return objectAssign({}, state, {
        typingMinConDurationValue: newTypingMinConDurationValue,
        typingMinMeetingDurationValue: newTypingMinMeetingDurationValue,
      });
    default:
      return state;
  }
};

export default reducer;
